import React from "react";

const customers = [
    { name: "NTT DATA", logo: "/images/logos/nttdata.png" },
    { name: "CRED", logo: "/images/logos/cred.png" },
    { name: "EuroSchool", logo: "/images/logos/eruoschool.png" },
    { name: "Bisleri", logo: "/images/logos/bisleri.png" },
    { name: "Bluefish", logo: "/images/logos/bluefish.png" },
    { name: "ArisGlobal", logo: "/images/logos/arisglobal.png" },
    { name: "Ogilvy", logo: "/images/logos/ogilvy.png" },
    { name: "Times Network", logo: "/images/logos/timesnetwork.png" },
    { name: "Mindlance", logo: "/images/logos/mindlance.png" },
    { name: "GMR", logo: "/images/logos/gmr.png" },
    { name: "Aurigene", logo: "/images/logos/aurigene.png" },
    { name: "Janatics", logo: "/images/logos/janatics.png" },
    { name: "Novozymes", logo: "/images/logos/novozymes.png" },
    { name: "JWT", logo: "/images/logos/jwt.png" },
    { name: "Yokogawa", logo: "/images/logos/yokogawa.png" },
    { name: "Schindler", logo: "/images/logos/schindler.png" },
];

export default function CustomersSection() {
    return (
        <section className="py-5 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 text-center">
                <p className="text-red-600 font-bold mb-1 flex items-center justify-center gap-2">
                    <span className="w-3 h-3 bg-theme-color rounded-full inline-block"></span> Our Customers
                </p>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-12">
                    We work with the best brands
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-8 items-center justify-items-center">
                    {customers.map((customer, index) => (
                        <div key={index} className="flex items-center justify-center">
                            <img
                                src={customer.logo}
                                alt={customer.name}
                                className="max-h-12 sm:max-h-16 lg:max-h-20 object-contain"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
